var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAllNew())?_c('div',[_c('MarginCalculatedNew')],1):_c('div',[_c('MarginCalculatedOld')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }